import React from 'react';
import CardBase from './CardBase';
import './Cards.css';
import GoogleMapIframe from './GoogleMapIframe';
import './GoogleMap.css';
import { useLang } from '../i18n';

function CardsInfo() {
  const { t } = useLang();
  return (
    <div className='cards'>
        <h1>{t('info.contactsTitle')}</h1>
        <div className='cards__container'>
            <div className='cards__wrapper'>
                <ul className='cards__items'>
                    <CardBase 
                    label={t('info.director')}
                    text='Michal Matejka'
                    phone={t('info.phoneNumber') + ' +421 903 645 790'}
                    email={t('info.email') + ' michal.matejka9@gmail.com'}
                    />
                    <CardBase
                    label={t('info.contactPerson')}
                    text='Jana Hliničanová'
                    phone={t('info.phoneNumber') + ' +43 676 348 5683'}
                    email={t('info.email') + ' sj.bedminton@gmail.com'}
                    />
                   <CardBase
                   label={t('info.venue')}
                   text={
                    <>
                        ARENA Ostrov 363,<br />
                        Zamarovce, Trenčín, Slovakia
                    </>
                    }
                    />
                </ul>
                <div className='cards__item'>
                    <div className='cards__item__base'>  
                        <GoogleMapIframe />
                    </div>
                </div>
            </div>
        </div>
    </div>
  );
}

export default CardsInfo;